import { create } from 'zustand';

interface WasserijItemDrawerState {
  openItemId: string | null;
  /**
   * Optionele blader-context: geordende item-ids van de lijst waaruit de
   * drawer geopend is. De drawer toont dan vorige/volgende zodat een lijst
   * (bv. vastgelopen kleden) item-voor-item verwerkt kan worden.
   */
  listIds: string[] | null;
  open: (id: string, listIds?: string[]) => void;
  close: () => void;
}

export const useWasserijItemDrawerStore = create<WasserijItemDrawerState>((set) => ({
  openItemId: null,
  listIds: null,
  open: (id, listIds) =>
    set((s) => ({
      openItemId: id,
      // Expliciete lijst wint; bladeren binnen de huidige lijst behoudt hem;
      // openen van buitenaf (zonder lijst) wist hem.
      listIds: listIds !== undefined ? listIds : s.listIds?.includes(id) ? s.listIds : null,
    })),
  close: () => set({ openItemId: null, listIds: null }),
}));

/** Encode current item id for the `?item=` query param. */
export function encodeItemParam(id: string | null): string | null {
  return id || null;
}

/**
 * Parse the `?item=` query param back into an id. SF-ids zijn 15/18 tekens
 * alfanumeriek; onder de cut-schakelaar munt de app `eigen-<uuid>` (zelfde
 * definitie als api/_lib/record-id.ts).
 */
const RECORD_ID_RE =
  /^(?:[a-zA-Z0-9]{15,18}|eigen-[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})$/;
export function parseItemParam(raw: string | null): string | null {
  if (!raw) return null;
  const trimmed = raw.trim();
  return RECORD_ID_RE.test(trimmed) ? trimmed : null;
}
